common.View.create('crud::form.inputs.Select', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initGUI();
    },

    /**
     * Initializes the Datetime picker.
     */
    initGUI()
    {
        this.showGrayPlaceholder();
        this.changeSelectPlaceholderColor();
    },

    showGrayPlaceholder()
    {
        this.element.find('select').addClass('default-option');
    },

    changeSelectPlaceholderColor()
    {
        this.element
            .find('select')
                .on('change', (event) => {
                    // Add default-option to select if no option is selected
                    if ($(event.target).find('option[value=""]:selected').length) {
                        $(event.target).addClass('default-option');
                    } else if( $(event.target).find('option[value=""]:not(:selected)').length ) {
                        $(event.target).removeClass('default-option');
                    }
                });
    }

});
